import { render } from "./UnauthorizedPage.vue?vue&type=template&id=995cac00"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=js"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__